import { render, staticRenderFns } from "./DataProfile.vue?vue&type=template&id=983e7ffc&scoped=true&"
import script from "./DataProfile.vue?vue&type=script&lang=js&"
export * from "./DataProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983e7ffc",
  null
  
)

export default component.exports